import { useParams } from 'react-router-dom';
import {
  selectIsLoadingGet,
  selectErrors
} from 'state/abandoned-cart/abandoned-cart-slice';
import { shallowEqual, useSelector } from 'react-redux';
import { AbandonedCart } from 'state/abandoned-cart/types/abandoned-cart';

const currentDate = new Date();

export const useAbandonedCart = () => {
  const { quoteId } = useParams();
  const isLoading = useSelector(selectIsLoadingGet, shallowEqual);
  const apiErrors = useSelector(selectErrors, shallowEqual);

  const getIsQuoteExpired = (abandonedCart: AbandonedCart) => {
    if (!abandonedCart?.createdTimeStamp) return true; // default scenario if no timestamp is available

    const createdDate = new Date(abandonedCart.createdTimeStamp.split('/').reverse().join('-'));
    const expirationDate = new Date(createdDate);
    expirationDate.setDate(expirationDate.getDate() + 28); // Add 28 days to the created date

    return currentDate > expirationDate;
  }

  return {
    quoteId,
    isLoading,
    apiErrors,
    getIsQuoteExpired
  }
}